// All imports at the top (required by JS modules)
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App';
import './styles/main.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);